'use client'

import { SettingsOutlined } from '@mui/icons-material'
import { SvgIcon } from '@mui/material'
import Link from 'next/link'
import { Colors } from '~/libs/mui/theme'

export function SettingsIconLink(): JSX.Element {
  return (
    <Link href='/setting'>
      <SvgIcon
        component={SettingsOutlined}
        sx={{
          color: Colors.color5A5957,
        }}
      />
    </Link>
  )
}
